module.exports = __webpack_public_path__ + "static/media/gryphon_community_events_s.797534e2.jpg";